<div class="sel-card"
     [class.sel-card--selected]="selected"
     [class.sel-card--disabled]="disabled"
     (click)="onClick()"
     role="button"
     tabindex="0"
     [attr.aria-pressed]="selected"
     (keydown.enter)="onClick()"
     (keydown.space)="onClick()">
  <div class="sel-card__indicator" [class.sel-card__indicator--radio]="mode === 'radio'">
    <span class="sel-card__check" *ngIf="selected">✓</span>
  </div>
  <div class="sel-card__icon" *ngIf="iconSrc">
    <img [src]="iconSrc" alt="">
  </div>
  <div class="sel-card__body">
    <div class="sel-card__title">{{ title }}</div>
    <div class="sel-card__desc" *ngIf="description">{{ description }}</div>
  </div>
</div>
